function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, InputNumber, DatePicker } from "antd";
import Common from "../includes/Common";
import dayjs from "dayjs";
import moment from "moment";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var EditSession = function EditSession(_ref) {
  var handler = _ref.handler,
    session = _ref.session;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    successMessage = _useState4[0],
    setSuccessMessage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFormProcessing = _useState6[0],
    setIsFormProcessing = _useState6[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setSuccessMessage('');
    var fData = new FormData();
    fData.append("start_date", values.start_date);
    fData.append("end_date", values.end_date);
    fData.append("price", values.price);
    fData.append("user_id", Common.currentUser.id);
    fData.append("id", session.id);
    setIsFormProcessing(true);
    axios.post(Common.baseApiUrl + "editsubject", fData).then(function (response) {
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      price: session.price,
      start_date: moment(session.start_date),
      end_date: moment(session.end_date)
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      form: form,
      onFinish: onFinish,
      children: [(errorMessage.length > 0 || successMessage.length > 0) && /*#__PURE__*/_jsxs(Form.Item, {
        children: [successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
          type: "success",
          message: successMessage,
          banner: true
        }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          banner: true
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Date de Debut",
        name: "start_date",
        rules: [{
          required: true,
          message: "Ce champ est obligatoire"
        }],
        children: /*#__PURE__*/_jsx(DatePicker, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Date de Fin",
        name: "end_date",
        rules: [{
          required: true,
          message: "Ce champ est obligatoire"
        }],
        children: /*#__PURE__*/_jsx(DatePicker, {
          format: "DD/MM/YYYY"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Prix",
        name: "price",
        rules: [{
          required: true,
          message: "Ce champ est obligatoire"
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          type: "primary",
          loading: isFormProcessing,
          htmlType: "submit",
          children: /*#__PURE__*/_jsx("b", {
            children: "SAUVEGARDER"
          })
        })
      })]
    })
  });
};
export default EditSession;